import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import Vue from 'vue'
import VueVirtualScroller from 'vue-virtual-scroller'

Vue.use(VueVirtualScroller)
